import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {ValidationErrorResponse} from '../../shared/models/validation-error-response';
import {DomainNameParserService} from '../../shared/services/domain-name-parser.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotUsernameService {

  private readonly serviceLayerHost;
  private readonly FORGOT_USERNAME_PATH = '/public/v1/dearborn/users/forgot-username';

  constructor(private http: HttpClient, private domainNameParserService: DomainNameParserService) {
    this.serviceLayerHost = environment.serviceLayer.host[domainNameParserService.getState()];
  }

  remindUsernameByEmail(email: string): Observable<ValidationErrorResponse> {
    return this.http.post<ValidationErrorResponse>(this.createForgotUsernameUrl(), null, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('email', email),
      observe: 'response'
    }).pipe(
      map(_ => {
        return null;
      }),
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.status === 400) {
          // return of(err.error);
          return of(JSON.parse(errorResponse.error.message));
        } else {
          console.error('Server returned error response. Details: ' + JSON.stringify(errorResponse));
          return throwError('Cannot parse response from SL server.');
        }
      })
    );
  }

  private createForgotUsernameUrl(): string {
    // return this.serviceLayerHost + this.FORGOT_USERNAME_PATH;
    return "sendUserNameByEmail";
  }
}
